import React from "react";
import Nav from "./components/landing/Nav";
import ScrollProgress from "./components/landing/ScrollProgress";
import Hero from "./components/landing/Hero";
import ProblemSolution from "./components/landing/ProblemSolution";
import Configurator from "./components/landing/Configurator";
import USP from "./components/landing/USP";
import References from "./components/landing/References";
import QuoteBlock from "./components/landing/QuoteBlock";
import Callback from "./components/landing/Callback";
import Chatbot from "./components/landing/Chatbot";
import EmailAutomation from "./components/landing/EmailAutomation";
import FinalCTA from "./components/landing/FinalCTA";
import Footer from "./components/landing/Footer";
import FloatingChat from "./components/landing/FloatingChat";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";

function App() {
  const [configuratorData, setConfiguratorData] = React.useState(null);

  return (
    <div className="App" data-testid="landing-app">
      <ScrollProgress />
      <Nav />
      <Hero />
      <ProblemSolution />
      <Configurator onChange={setConfiguratorData} />
      <USP />
      <References />
      <QuoteBlock configuratorData={configuratorData} />
      <Callback />
      <Chatbot />
      <EmailAutomation />
      <FinalCTA />
      <Footer />
      <FloatingChat />
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
